module.exports = __webpack_public_path__ + "assets/img/8_1595_big.61e87d01.jpg";